import {
  getFullName,
  getSystemTime,
  isDataValid,
  isDefined,
  jsGetAge,
  objectCopy,
  isEqual
} from "../../shared/utils";
import { formatDate, paramNormal } from "../../shared/filters";
import {
  cartesian2polar,
  FILES,
  FLATCOLOR,
  isPointInCircle,
  MAPSTYLES,
  STEEPCOLOR
} from "../shared";
import DataParams from "../dataGetters/params";
import TopographyProc from "../js/TopographyRecordProc";
import fileSys from "../../fileoprators/fileSystem";
import GenReportMap from "../js/GenReportMap";
import { calcElevDiff } from "./calc4mmElevDiff";
import { getKeraColor } from "../shared/util";
import FourierCalculate from "./FourierCalculate";
let genReportMap = null;
let mapValues = null;
let topographyProc = new TopographyProc();
let values = new Array(66);
values.fill(-1000);

let allData = {
  cfg: {},
  data: { patientInfo: {}, OS: {}, OD: {}, printFlags: {} },
  record: {}
};
function getCheckTime(eyeType) {
  if (isContentValid(eyeType, "topography")) {
    return formatDate(
      allData.record.content[`data${eyeType}`].topography.testtime,
      allData.cfg.dateFormat,
      true
    );
  } else {
    return "";
  }
}
function _init(eyeType) {
  let fourmapsDrawSettings = allData.cfg.mapDrawSettings.fourmaps;

  // fourmapsDrawSettings.mapInForm0.shapes.ShowDiameter9mm =
  //   fourmapsDrawSettings.mapInForm1.shapes.ShowDiameter9mm =
  //   fourmapsDrawSettings.mapInForm2.shapes.ShowDiameter9mm =
  //   fourmapsDrawSettings.mapInForm3.shapes.ShowDiameter9mm = false
  allData.data.isDiameter = window.dataShowSettings.isDiameter;
  allData.data.isCartesian = window.dataShowSettings.isCartesian;
  allData.data.pupilcornea = window.magecoe.pupilcornea;
  allData.data[eyeType].checkTime = getCheckTime(eyeType);
  allData.data[eyeType].fourMaps = {
    sCurvature: {
      cliPath: fourmapsDrawSettings.mapInForm0.shapes.ShowDiameter9mm
        ? "clip-path9mm"
        : "clip-path",
      trans: fourmapsDrawSettings.mapInForm0.shapes.ShowDiameter9mm ? "trans" : "img-width",
      map: window.__ct__.debug ? fileSys.getMockPath("map.jpg").replace(/\\/g, "\\\\") : "",
      colorBarURL: window.__ct__.debug
        ? fileSys.getMockPath("colorbar.jpg").replace(/\\/g, "\\\\")
        : "",
      numValsMap: "",
      numVals: null,
      minMaxVals: null
    },
    tCurvature: {
      cliPath: fourmapsDrawSettings.mapInForm1.shapes.ShowDiameter9mm
        ? "clip-path9mm"
        : "clip-path",
      trans: fourmapsDrawSettings.mapInForm1.shapes.ShowDiameter9mm ? "trans" : "img-width",
      map: window.__ct__.debug ? fileSys.getMockPath("map.jpg").replace(/\\/g, "\\\\") : "",
      colorBarURL: window.__ct__.debug
        ? fileSys.getMockPath("colorbar.jpg").replace(/\\/g, "\\\\")
        : "",
      numVals: null,
      minMaxVals: null,
      numValsMap: ""
    },
    elevation: {
      cliPath: fourmapsDrawSettings.mapInForm2.shapes.ShowDiameter9mm
        ? "clip-path9mm"
        : "clip-path",
      trans: fourmapsDrawSettings.mapInForm2.shapes.ShowDiameter9mm ? "trans" : "img-width",
      map: window.__ct__.debug ? fileSys.getMockPath("map.jpg").replace(/\\/g, "\\\\") : "",
      colorBarURL: window.__ct__.debug
        ? fileSys.getMockPath("colorbar.jpg").replace(/\\/g, "\\\\")
        : "",
      numVals: null,
      minMaxVals: null,
      numValsMap: ""
    },
    frp: {
      cliPath: fourmapsDrawSettings.mapInForm3.shapes.ShowDiameter9mm
        ? "clip-path9mm"
        : "clip-path",
      trans: fourmapsDrawSettings.mapInForm3.shapes.ShowDiameter9mm ? "trans" : "img-width",
      map: window.__ct__.debug ? fileSys.getMockPath("map.jpg").replace(/\\/g, "\\\\") : "",
      colorBarURL: window.__ct__.debug
        ? fileSys.getMockPath("colorbar.jpg").replace(/\\/g, "\\\\")
        : "",
      numVals: null,
      minMaxVals: null,
      numValsMap: ""
    }
  };
  let largemapSettings = window.mapDrawSettings.largemap;
  allData.data[eyeType].heightFAndTFSQ = {
    heightF: {
      cliPath: largemapSettings.mapInForm0.shapes.ShowDiameter9mm ? "clip-path9mm" : "clip-path",
      trans: largemapSettings.mapInForm0.shapes.ShowDiameter9mm ? "trans" : "img-width",
      map: window.__ct__.debug ? fileSys.getMockPath("map.jpg").replace(/\\/g, "\\\\") : "",
      colorBarURL: window.__ct__.debug
        ? fileSys.getMockPath("colorbar.jpg").replace(/\\/g, "\\\\")
        : "",
      numVals: null,
      minMaxVals: null,
      numValsMap: ""
    },
    tfsq: {
      cliPath: largemapSettings.mapInForm0.shapes.ShowDiameter9mm ? "clip-path9mm" : "clip-path",
      trans: largemapSettings.mapInForm0.shapes.ShowDiameter9mm ? "trans" : "img-width",
      map: window.__ct__.debug ? fileSys.getMockPath("map.jpg").replace(/\\/g, "\\\\") : "",
      colorBarURL: window.__ct__.debug
        ? fileSys.getMockPath("colorbar.jpg").replace(/\\/g, "\\\\")
        : "",
      numVals: null,
      minMaxVals: null,
      numValsMap: ""
    }
  };
  let fourierAnalysisSettings = window.mapDrawSettings.fourierAnalysis;
  allData.data[eyeType].fourierAnalysis = {
    sphericalComponent: {
      cliPath: fourierAnalysisSettings.mapInForm0.shapes.ShowDiameter9mm
        ? "clip-path9mm"
        : "clip-path",
      trans: fourierAnalysisSettings.mapInForm0.shapes.ShowDiameter9mm ? "trans" : "img-width",
      map: window.__ct__.debug ? fileSys.getMockPath("map.jpg").replace(/\\/g, "\\\\") : "",
      colorBarURL: window.__ct__.debug
        ? fileSys.getMockPath("colorbar.jpg").replace(/\\/g, "\\\\")
        : "",
      numVals: null,
      minMaxVals: null,
      numValsMap: ""
    },
    decentration: {
      cliPath: fourierAnalysisSettings.mapInForm1.shapes.ShowDiameter9mm
        ? "clip-path9mm"
        : "clip-path",
      trans: fourierAnalysisSettings.mapInForm1.shapes.ShowDiameter9mm ? "trans" : "img-width",
      map: window.__ct__.debug ? fileSys.getMockPath("map.jpg").replace(/\\/g, "\\\\") : "",
      colorBarURL: window.__ct__.debug
        ? fileSys.getMockPath("colorbar.jpg").replace(/\\/g, "\\\\")
        : "",
      numVals: null,
      minMaxVals: null,
      numValsMap: ""
    },
    regularAstigmatism: {
      cliPath: fourierAnalysisSettings.mapInForm3.shapes.ShowDiameter9mm
        ? "clip-path9mm"
        : "clip-path",
      trans: fourierAnalysisSettings.mapInForm3.shapes.ShowDiameter9mm ? "trans" : "img-width",
      map: window.__ct__.debug ? fileSys.getMockPath("map.jpg").replace(/\\/g, "\\\\") : "",
      colorBarURL: window.__ct__.debug
        ? fileSys.getMockPath("colorbar.jpg").replace(/\\/g, "\\\\")
        : "",
      numVals: null,
      minMaxVals: null,
      numValsMap: ""
    },
    irregularity: {
      cliPath: fourierAnalysisSettings.mapInForm4.shapes.ShowDiameter9mm
        ? "clip-path9mm"
        : "clip-path",
      trans: fourierAnalysisSettings.mapInForm4.shapes.ShowDiameter9mm ? "trans" : "img-width",
      map: window.__ct__.debug ? fileSys.getMockPath("map.jpg").replace(/\\/g, "\\\\") : "",
      colorBarURL: window.__ct__.debug
        ? fileSys.getMockPath("colorbar.jpg").replace(/\\/g, "\\\\")
        : "",
      numVals: null,
      minMaxVals: null,
      numValsMap: ""
    },
    paramsSph: {},
    paramsDecent: {},
    paramsRegular: {},
    paramsIrregular: {}
  };
  allData.data[eyeType].sCurvature = {
    isPrinted: window.__ct__.debug,
    maps: allData.data[eyeType].fourMaps.sCurvature,
    title: allData.cfg.langcfg.txtSCurvatureF
  };
  allData.data[eyeType].tCurvature = {
    isPrinted: window.__ct__.debug,
    maps: allData.data[eyeType].fourMaps.tCurvature,
    title: allData.cfg.langcfg.txtTCurvatureF
  };
  allData.data[eyeType].elevation = {
    isPrinted: window.__ct__.debug,
    maps: allData.data[eyeType].fourMaps.elevation,
    title: allData.cfg.langcfg.txtElevationF
  };
  allData.data[eyeType].frp = {
    isPrinted: window.__ct__.debug,
    maps: allData.data[eyeType].fourMaps.frp,
    title: allData.cfg.langcfg.txtFRP
  };
  allData.data[eyeType].heightF = {
    isPrinted: window.__ct__.debug,
    maps: allData.data[eyeType].heightFAndTFSQ.heightF,
    title: allData.cfg.langcfg.txtHeightF
  };
  allData.data[eyeType].tfsq = {
    isPrinted: window.__ct__.debug,
    maps: allData.data[eyeType].heightFAndTFSQ.tfsq,
    title: allData.cfg.langcfg.txtTFSQ
  };
  allData.data[eyeType].sphericalComponent = {
    isPrinted: window.__ct__.debug,
    maps: allData.data[eyeType].fourierAnalysis.sphericalComponent,
    title: allData.cfg.langcfg.txtSphericalComponent
  };
  allData.data[eyeType].decentration = {
    isPrinted: window.__ct__.debug,
    maps: allData.data[eyeType].fourierAnalysis.decentration,
    title: allData.cfg.langcfg.txtDecentration
  };
  allData.data[eyeType].regularAstigmatism = {
    isPrinted: window.__ct__.debug,
    maps: allData.data[eyeType].fourierAnalysis.regularAstigmatism,
    title: allData.cfg.langcfg.txtRegularAstigmatism
  };
  allData.data[eyeType].irregularity = {
    isPrinted: window.__ct__.debug,
    maps: allData.data[eyeType].fourierAnalysis.irregularity,
    title: allData.cfg.langcfg.txtIrregularity
  };

  allData.data[eyeType].aberration = {
    params: [],
    svgPath: fileSys.getCfgPath("img/zernikes/"),
    values: values,
    map: window.__ct__.debug ? fileSys.getMockPath("map.jpg").replace(/\\/g, "\\\\") : "",
    isPrinted: window.__ct__.debug,
    zernikeSet: window.zernikeSet,
    maxPeak: { x: "--", y: "--" },
    meanRms: { mean: "--", rms: "--" },
    retinal: {
      image: window.__ct__.debug ? fileSys.getMockPath("E.bmp") : "",
      title: "psf"
    },
    psf: {
      image: window.__ct__.debug ? fileSys.getMockPath("E.bmp") : "",
      title: "psf",
      label: "fdf"
    },
    chart: {
      image: window.__ct__.debug ? fileSys.getMockPath("E.bmp") : "",
      title: "psf"
    }
  };
  let keratoconusDrawSettings = allData.cfg.mapDrawSettings.keratoconus;
  allData.data[eyeType].keratoconus = {
    isPrinted: window.__ct__.debug,
    sCurvature: {
      title: allData.cfg.langcfg.txtSCurvatureF,
      cliPath: keratoconusDrawSettings.mapInForm0.shapes.ShowDiameter9mm
        ? "clip-path9mm"
        : "clip-path",
      trans: keratoconusDrawSettings.mapInForm0.shapes.ShowDiameter9mm ? "trans" : "img-width",
      map: window.__ct__.debug ? fileSys.getMockPath("map.jpg").replace(/\\/g, "\\\\") : "",
      colorBarURL: window.__ct__.debug
        ? fileSys.getMockPath("colorbar.jpg").replace(/\\/g, "\\\\")
        : "",
      numVals: null,
      minMaxVals: null,
      numValsMap: "",

      dia: keratoconusDrawSettings.mapInForm0.shapes.ShowDiameter9mm ? 9 : 12
    },
    elevation: {
      title: allData.cfg.langcfg.txtElevationF,
      cliPath: keratoconusDrawSettings.mapInForm1.shapes.ShowDiameter9mm
        ? "clip-path9mm"
        : "clip-path",
      trans: keratoconusDrawSettings.mapInForm1.shapes.ShowDiameter9mm ? "trans" : "img-width",
      map: window.__ct__.debug ? fileSys.getMockPath("map.jpg").replace(/\\/g, "\\\\") : "",
      colorBarURL: window.__ct__.debug
        ? fileSys.getMockPath("colorbar.jpg").replace(/\\/g, "\\\\")
        : "",
      numVals: null,
      minMaxVals: null,
      numValsMap: "",
      dia: keratoconusDrawSettings.mapInForm1.shapes.ShowDiameter9mm ? 9 : 12
    }
  };
  let isNewPupil =
    isContentValid(eyeType, "pupilcorneadia_dark") ||
    isContentValid(eyeType, "pupilcorneadia_lowerMiddle") ||
    isContentValid(eyeType, "pupilcorneadia_middle") ||
    isContentValid(eyeType, "pupilcorneadia_bright");
  allData.data[eyeType].pupilCornea = {
    isPrinted: window.__ct__.debug,
    ...(isNewPupil
      ? { dark: {}, lowerMiddle: {}, middle: {}, bright: {}, corneadia: {}, seriesData: "" }
      : { cornea: {}, pupil: {} }),
    dist: "--",
    image: window.__ct__.debug ? fileSys.getMockPath("map.jpg") : "",
    circleImage: ""
  };
}
function normalPatient(patient) {
  const age = jsGetAge(patient.birthday);
  allData.data.patientInfo.name = getFullName(patient);
  allData.data.patientInfo.pid = patient.pid;
  allData.data.patientInfo.sex =
    patient.sex === "M"
      ? allData.cfg.langcfg.txtMale
      : patient.sex === "F"
        ? allData.cfg.langcfg.txtFemale
        : patient.sex === "O"
          ? allData.cfg.langcfg.txtSexOther
          : patient.sex === "U"
            ? allData.cfg.langcfg.txtSexUnknown
            : "";
  allData.data.patientInfo.age = age < 0 ? "" : age;
  allData.data.patientInfo.birthday = patient.birthday;
  allData.data.patientInfo.isAnonymous = !window.printSettings.general.anonymous.patientinfo;
}

function normalMapValues(dataParams, eyeType, medianMode, mm) {
  let _mapValues = {};
  dataParams.getBaseParams();
  _mapValues.params = dataParams.params;
  _mapValues.eyeType = eyeType;
  dataParams.getMajMedian(medianMode);
  _mapValues.frontpValOfMajMeridians = dataParams.frontpValOfMajMeridians;
  _mapValues.isShowGrayF = dataParams.isShowGrayF;
  _mapValues.majMedian = dataParams.majMedian;
  dataParams.getSagCurMedian();
  _mapValues.sagCurMedian = dataParams.sagcurMedian;
  _mapValues.params.EccPEQ.value = dataParams.getOneMajMedian(mm);
  return _mapValues;
}
function normalKeratoconusParams(params) {
  const KEYS = ["SAI", "SRI", "SDP", "DSI", "OSI", "CSI", "IAI", "KPI", "IS", "KISA"];
  let data = {};
  KEYS.forEach((key) => {
    data[key] = {
      value: paramNormal((params[key] || { value: -1000 }).value),
      color: getKeraColor((params[key] || { value: -1000 }).value, key)
    };
  });
  return data;
}
async function initMapValues(eyeType) {
  let casePath;
  if (isContentValid(eyeType, "topography")) {
    try {
      casePath = await topographyProc.getRecord(allData.record, eyeType);
    } catch (e) {
      casePath = null;
    }
    let dataParams = new DataParams(casePath);
    const { medianMode, mm } = allData.cfg.dataShowSettings;
    mapValues = normalMapValues(dataParams, eyeType, medianMode, mm);
    dataParams.getMajMedian(allData.cfg.dataShowSettings.medianMode);
    mapValues.params.EccPEQ.value = dataParams.getOneMajMedian(allData.cfg.dataShowSettings.mm);
    mapValues.params.elevDiff4mm.value = calcElevDiff(
      casePath,
      mapValues.params.AxisFlat.value,
      mapValues.params.AxisSteep.value
    ).val;
    allData.data[eyeType].params = normalParams(mapValues.params);
    allData.data[eyeType].keraParams = normalKeratoconusParams(mapValues.params);
  }
  return casePath;
}
function getRhRf(params) {
  return paramNormal(allData.cfg.dataShowSettings.isRhRv ? params["Rh"].value : params["Rf"].value);
}
function getRvRs(params) {
  return paramNormal(allData.cfg.dataShowSettings.isRhRv ? params["Rv"].value : params["Rs"].value);
}
function getCartesianPolar(params, keyX, keyY) {
  if (allData.cfg.dataShowSettings.isCartesian) {
    return `${paramNormal(params[keyX].value)}mm, ${paramNormal(params[keyY].value)}mm`;
  } else {
    if (isDataValid(params[keyX].value) && isDataValid(params[keyY].value)) {
      let { dist, angle } = cartesian2polar(params[keyX].value, params[keyY].value);
      return `${paramNormal(dist)}mm@${paramNormal(angle, {
        fixed: 0,
        rpText: "--"
      })}°`;
    } else {
      return `--mm@--°`;
    }
  }
}
function normalParams(params) {
  if (!isDefined(params)) return [];
  let paramValues = [];
  let obj = {
    label: `K1/${allData.cfg.RhRfTitle}:`,
    value: `${paramNormal(params["K1"].value)}D@${paramNormal(
      params["AxisFlat"].value
    )}° / ${getRhRf(params)}mm`,
    color: FLATCOLOR
  };
  paramValues.push(obj);
  obj = {
    label: `K2/${allData.cfg.RvRsTitle}:`,
    value: `${paramNormal(params["K2"].value)}D@${paramNormal(
      params["AxisSteep"].value
    )}° / ${getRvRs(params)} mm`,
    color: STEEPCOLOR
  };
  paramValues.push(obj);
  obj = {
    label: `Km/Rm:`,
    value: `${paramNormal(params["Km"].value)}D / ${paramNormal(params["Rm"].value)}mm`
  };
  paramValues.push(obj);
  let astig = -1000;
  let axis = -1000;
  if (isDataValid(params["K1"].value) && isDataValid(params["K2"].value)) {
    astig = params["K1"].value - params["K2"].value;
  }
  if (isDataValid(params["AxisFlat"].value) && isDataValid(params["AxisSteep"].value)) {
    axis = params["AxisFlat"].value;
  }
  obj = {
    label: `Astig:`,
    value: `${paramNormal(astig)}D / ${paramNormal(axis)}°`
  };
  paramValues.push(obj);

  obj = {
    label: "Kmax/Rmin:",
    value: `${paramNormal(params["Kmax"].value)}D / ${paramNormal(
      params["Rmin"].value
    )}mm (${getCartesianPolar(params, "RminX", "RminY")})`,
    isLong: true
  };

  paramValues.push(obj);
  obj = {
    label: `${allData.cfg.langcfg.txtDiffHightD8}:`,
    value: `${paramNormal(params["elevDiff4mm"].value, { fixed: 0 })}μm`
  };
  paramValues.push(obj);
  obj = {
    label: allData.cfg.eccPEQTitle,
    value: `${paramNormal(params["EccPEQ"].value)}`
  };
  paramValues.push(obj);

  // obj = {
  //   label: `SRI:`,
  //   value: `${paramNormal(params['SRI'].value)}`,
  //   bgColor: getKeraColor(params['SRI'].value, 'SRI')
  // }
  // paramValues.push(obj)
  // obj = {
  //   label: `SAI:`,
  //   value: `${paramNormal(params['SAI'].value)}`,
  //   bgColor: getKeraColor(params['SAI'].value, 'SAI')

  // }
  // paramValues.push(obj)
  // obj = {
  //   label: `IS:`,
  //   value: `${paramNormal(params['IS'].value)} D`,
  //   bgColor: getKeraColor(params['IS'].value, 'IS')

  // }
  // paramValues.push(obj)
  return paramValues;
}
function getColor(flag) {
  return flag ? FLATCOLOR : STEEPCOLOR;
}

function calcMaxMinStartPoint(endX, endY, radius, ratio) {
  let angle = Math.atan2(endX, endY);
  let r = radius === 0 ? 1.5 : radius + 1;
  let point = {
    start: {
      x: normalXYInMap(radius * Math.cos(Math.PI / 2 - angle), ratio),
      y: normalXYInMap(radius * Math.sin(Math.PI / 2 - angle), ratio, true)
    },

    end: {
      x: normalXYInMap(r * Math.cos(Math.PI / 2 - angle), ratio),
      y: normalXYInMap(r * Math.sin(Math.PI / 2 - angle), ratio, true)
    },
    isHorizon: Math.abs(angle) < Math.PI / 4 || Math.abs(angle) > (Math.PI * 3) / 4
  };
  return point;
}
function drawMaxMinVals(ctx, points, ratio) {
  ctx.beginPath();
  ctx.lineWidth = 6;
  let innerR = 0;
  let r = 601 / 2.0;
  let size = measureText(ctx, "");
  let w = size.width;
  let h = size.height;
  let cnt = 0;
  points.map((item, index) => {
    if (index === 0) {
      innerR = 0;
    } else if (index % 4 === 0) {
      innerR = innerR === 0 ? 1.5 : innerR + 1;
    }
    if (cnt === 4) {
      cnt = 0;
    }
    let point = calcMaxMinStartPoint(item.x, item.y, innerR, ratio);
    if (isPointInCircle(point.end.x, point.end.y, r)) {
      ctx.beginPath();
      ctx.lineWidth = 8;
      ctx.strokeStyle = "red";
      ctx.moveTo(point.start.x, point.start.y);
      ctx.lineTo(point.end.x, point.end.y);
      ctx.stroke();
      ctx.beginPath();
      ctx.lineWidth = 6;
      ctx.strokeStyle = getColor(cnt < 2);
      ctx.moveTo(point.start.x, point.start.y);
      ctx.lineTo(point.end.x, point.end.y);
      ctx.stroke();
      let text = item.value;
      if (text && text.length > 0) {
        w = measureText(ctx, text).width;
        let oy = point.isHorizon ? h + 4 : 0;
        ctx.fillStyle = "black";
        console.log(
          (point.start.x + point.end.x) / 2 - w / 2 - 2,
          (point.start.y + point.end.y) / 2 - h - 4 + oy,
          w + 4,
          h + 8
        );
        ctx.fillRect(
          (point.start.x + point.end.x) / 2 - w / 2 - 2,
          (point.start.y + point.end.y) / 2 - h - 4 + oy,
          w + 8,
          h + 8
        );
        ctx.fillStyle = getColor(cnt < 2);
        ctx.fillText(
          text,
          (point.start.x + point.end.x) / 2 - w / 2,
          (point.start.y + point.end.y) / 2 + oy
        );
      }
    }
    cnt++;
  });
}
function normalXYInMap(v, ratio, isY = false) {
  return isY ? -1 * v * ratio : v * ratio;
}

function normalMinMaxVals(vals) {
  let _points = [];
  if (isDefined(vals)) {
    vals.px.map((item, index) => {
      if (
        isDataValid(item) &&
        isDefined(vals.py) &&
        isDefined(vals.pz) &&
        isDataValid(vals.pz[index])
      ) {
        _points.push({
          x: item,
          y: vals.py[index],
          value: isDataValid(vals.pz[index]) ? vals.pz[index]._toFixed(1) : ""
        });
      }
    });
  }
  return _points;
}
function drawMaxMin(ctx, ratio, values, dia) {
  if (!isDefined(values) || values.length <= 0) return false;
  let size = measureText(ctx, "");
  let w = size.width;
  let h = size.height;
  ctx.save("translate");
  ctx.strokeStyle = ctx.fillStyle = "black";
  let r = 601 / 2.0;
  for (let id = 1; id <= dia / 2; id++) {
    if (normalXYInMap(id, ratio) < r) {
      ctx.beginPath();
      let i = id + 0.5;
      let text = (i * 2).toString();
      size = measureText(ctx, text);
      w = size.width;
      h = size.height;
      let offsetAngle = Math.atan2(h / 2 + 5, normalXYInMap(i, ratio));
      ctx.fillText(text, normalXYInMap(i, ratio, true) - w / 2, h / 2);
      ctx.fillText(text, normalXYInMap(i, ratio) - w / 2, h / 2);
      // 绘制弧
      ctx.beginPath();
      ctx.arc(0, 0, normalXYInMap(i, ratio), offsetAngle, Math.PI * 2);
      ctx.stroke();
      ctx.beginPath();
      ctx.arc(0, 0, normalXYInMap(i, ratio) - offsetAngle, Math.PI * 2, true);
      ctx.stroke();
    }
  }
  let _values = normalMinMaxVals(values);
  drawMaxMinVals(ctx, _values, ratio);
  ctx.restore("translate");
  return true;
}
function normalNumValuesPoints(pointsX, pointsY, pointsZ = null, ratio, fixed = 2) {
  let _points = [];
  let pointsLen = pointsZ.length;
  for (let i = 0; i < pointsLen; i++) {
    if (isDataValid(pointsX[i]) && isDataValid(pointsY[i])) {
      if (!isDefined(pointsZ) || (isDefined(pointsZ) && isDataValid(pointsZ[i]))) {
        _points.push({
          x: normalXYInMap(pointsX[i], ratio),
          y: normalXYInMap(pointsY[i], ratio, true),
          value: isDefined(pointsZ) ? pointsZ[i]._toFixed(fixed) : null
        });
      }
    }
  }
  return _points;
}
function measureText(ctx, str) {
  let w = ctx.measureText(str).width;
  let h = ctx.measureText("Z").width;
  return {
    width: w,
    height: h
  };
}
function drawNumVals(ctx, ratio, values, fix) {
  if (!isDefined(values) || values.length <= 0) return false;
  ctx.save("translate");
  ctx.fillStyle = "black";
  let points = normalNumValuesPoints(values.px, values.py, values.pz, ratio, fix);
  let size = measureText(ctx, "");
  let w = size.width;
  let h = size.height;

  let radius = 601 / 2.0;
  points.map((item, index) => {
    w = measureText(ctx, item.value).width;
    if (isPointInCircle(item.x, item.y, radius)) {
      ctx.fillText(item.value, item.x - w / 2.0, item.y + h / 2.0);
    }
  });
  ctx.restore("translate");
  return true;
}
function draw3579mmRings(ctx, ratio) {
  ctx.save("translate");
  ctx.fillStyle = "black";
  ctx.strokeStyle = "black";
  let arr = [3, 5, 7, 9];
  arr.forEach((e) => {
    ctx.beginPath();
    ctx.arc(0, 0, (ratio * e) / 2, 0, Math.PI * 2);
    ctx.stroke();
  });
  ctx.restore("translate");
}
function renderMapValues(dia = 9, numVals, minMaxVals, mapstyle, shapes = {}) {
  dia = 12;
  let canvas = document.createElement("canvas");
  canvas.width = 601;
  canvas.height = 601;
  canvas.style.width = "601px";
  canvas.style.height = "601px";
  canvas.style.visibility = "hidden";
  let ctx = canvas.getContext("2d");
  let center = canvas.width / 2.0;
  ctx.translate(center, center);
  let fontsize = 20;
  ctx.font = `${fontsize}px arial`;
  let ratio = canvas.width / dia;
  let fix = mapstyle === MAPSTYLES.ElevationF ? 0 : 2;
  if (shapes.Show3579Ring) {
    draw3579mmRings(ctx, ratio);
  }
  if (shapes.ShowApexPosition) {
    drawApexPosition(ctx, ratio);
  }
  if (shapes.ShowMinRadiusF) {
    drawMinRadiusF(ctx, ratio);
  }
  let resultNumVals = drawNumVals(ctx, ratio, numVals, fix);
  let resultMinMaxVals = drawMaxMin(ctx, ratio, minMaxVals, dia);
  if (
    resultNumVals ||
    resultMinMaxVals ||
    shapes.Show3579Ring ||
    shapes.ShowApexPosition ||
    shapes.ShowMinRadiusF
  ) {
    return canvas.toDataURL();
  }
  return "";
}

function drawApexPosition(ctx, ratio) {
  function _dataInMap(v, isY = false) {
    return isY ? -1 * v * ratio : v * ratio;
  }
  function isDataValid(v) {
    return !isEqual(v, -1000, 0.0001);
  }
  function _isPositionXYValid(...args) {
    for (let i = 0; i < args.length; i++) {
      if (!isDefined(args[i]) || !isDataValid(args[i].value)) return false;
      else return true;
    }
  }
  const { PachyApexX, PachyApexY } = { PachyApexX: { value: 0 }, PachyApexY: { value: 0 } };
  if (_isPositionXYValid(PachyApexX, PachyApexY)) {
    ctx.save("translate");
    let x = _dataInMap(PachyApexX.value);
    let y = _dataInMap(PachyApexY.value, true);
    const len = 26;
    ctx.beginPath();
    ctx.fillStyle = "white";
    ctx.arc(x, y, len / 2, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore("translate");
  }
}

function drawMinRadiusF(ctx, ratio) {
  function _dataInMap(v, isY = false) {
    return isY ? -1 * v * ratio : v * ratio;
  }
  function isDataValid(v) {
    return !isEqual(v, -1000, 0.0001);
  }
  function _isPositionXYValid(...args) {
    for (let i = 0; i < args.length; i++) {
      if (!isDefined(args[i]) || !isDataValid(args[i].value)) return false;
      else return true;
    }
  }
  const { RminX, RminY } = mapValues.params;
  if (_isPositionXYValid(RminX, RminY)) {
    ctx.save("translate");
    let x = _dataInMap(RminX.value);
    let y = _dataInMap(RminY.value, true);
    const len = 26;
    ctx.beginPath();
    ctx.fillStyle = "white";
    ctx.moveTo(-len / 2 + x, y);
    ctx.lineTo(x, -len / 2 + y);
    ctx.lineTo(len / 2 + x, y);
    ctx.lineTo(x, len / 2 + y);
    ctx.closePath();
    ctx.fill();
    ctx.restore("translate");
  }
}

function isFourMapsPrinted() {
  let flag = false;
  const fourMaps = allData.cfg.printSettings.topography.bino.FourMaps;
  for (const id in fourMaps) {
    if (fourMaps[id]) {
      flag = true;
    }
  }
  return flag;
}
function normalFourMaps(casePath, eyeType) {
  genReportMap = null;
  // const { FourMaps } = allData.cfg.printSettings.topography.bino
  // if (isFourMapsPrinted() && !window.__ct__.debug) {
  if (
    allData.cfg.printSettings.topography.reportName_bino.includes("fourmaps") &&
    !window.__ct__.debug
  ) {
    let fourmapsDrawSettings = allData.cfg.mapDrawSettings.fourmaps;

    let dia = 12;
    let obj;
    if (
      allData.record &&
      allData.record.content[`data${eyeType}`]["topography"] &&
      allData.record.content[`data${eyeType}`]["topography"].diagnosed
    ) {
      if (!isDefined(genReportMap)) genReportMap = new GenReportMap(casePath, 0xffffffff);
      obj = genReportMap.getMap(MAPSTYLES.TCurvatureF, 0);
      allData.data[eyeType].fourMaps.tCurvature.map = obj.mapURL;
      allData.data[eyeType].fourMaps.tCurvature.colorBarURL = obj.colorBarURL;
      if (fourmapsDrawSettings.mapInForm0.shapes.ShowNumericValues) {
        allData.data[eyeType].fourMaps.tCurvature.numVals = obj.numVals;
      }
      if (fourmapsDrawSettings.mapInForm0.shapes.ShowMaxMin) {
        allData.data[eyeType].fourMaps.tCurvature.minMaxVals = obj.minMaxVals;
      }
      dia = fourmapsDrawSettings.mapInForm0.shapes.ShowDiameter9mm ? 9 : 12;
      allData.data[eyeType].fourMaps.tCurvature.numValsMap = renderMapValues(
        dia,
        allData.data[eyeType].fourMaps.tCurvature.numVals,
        allData.data[eyeType].fourMaps.tCurvature.minMaxVals,
        MAPSTYLES.TCurvatureF,
        fourmapsDrawSettings.mapInForm0.shapes
      );
      allData.data[eyeType].tCurvature = {
        isPrinted: true,
        maps: allData.data[eyeType].fourMaps.tCurvature,
        title: allData.cfg.langcfg.txtTCurvatureF,
        dia
      };
      if (!isDefined(genReportMap)) genReportMap = new GenReportMap(casePath, 0xffffffff);
      obj = genReportMap.getMap(MAPSTYLES.SCurvatureF, 1);
      allData.data[eyeType].fourMaps.sCurvature.map = obj.mapURL;
      allData.data[eyeType].fourMaps.sCurvature.colorBarURL = obj.colorBarURL;
      if (fourmapsDrawSettings.mapInForm1.shapes.ShowNumericValues) {
        allData.data[eyeType].fourMaps.sCurvature.numVals = obj.numVals;
      }
      if (fourmapsDrawSettings.mapInForm1.shapes.ShowMaxMin) {
        allData.data[eyeType].fourMaps.sCurvature.minMaxVals = obj.minMaxVals;
      }
      dia = fourmapsDrawSettings.mapInForm1.shapes.ShowDiameter9mm ? 9 : 12;
      allData.data[eyeType].fourMaps.sCurvature.numValsMap = renderMapValues(
        dia,
        allData.data[eyeType].fourMaps.sCurvature.numVals,
        allData.data[eyeType].fourMaps.sCurvature.minMaxVals,
        MAPSTYLES.SCurvatureF,
        fourmapsDrawSettings.mapInForm1.shapes
      );
      allData.data[eyeType].sCurvature = {
        isPrinted: true,
        maps: allData.data[eyeType].fourMaps.sCurvature,
        title: allData.cfg.langcfg.txtSCurvatureF,
        dia
      };
      if (!isDefined(genReportMap)) genReportMap = new GenReportMap(casePath, 0xffffffff);
      obj = genReportMap.getMap(MAPSTYLES.ElevationF, 2);
      allData.data[eyeType].fourMaps.elevation.map = obj.mapURL;
      allData.data[eyeType].fourMaps.elevation.colorBarURL = obj.colorBarURL;
      if (fourmapsDrawSettings.mapInForm2.shapes.ShowNumericValues) {
        allData.data[eyeType].fourMaps.elevation.numVals = obj.numVals;
      }
      if (fourmapsDrawSettings.mapInForm2.shapes.ShowMaxMin) {
        allData.data[eyeType].fourMaps.elevation.minMaxVals = obj.minMaxVals;
      }
      dia = fourmapsDrawSettings.mapInForm2.shapes.ShowDiameter9mm ? 9 : 12;
      allData.data[eyeType].fourMaps.elevation.numValsMap = renderMapValues(
        dia,
        allData.data[eyeType].fourMaps.elevation.numVals,
        allData.data[eyeType].fourMaps.elevation.minMaxVals,
        MAPSTYLES.ElevationF,
        fourmapsDrawSettings.mapInForm2.shapes
      );
      allData.data[eyeType].elevation = {
        isPrinted: true,
        maps: allData.data[eyeType].fourMaps.elevation,
        title: allData.cfg.langcfg.txtElevationF,
        dia
      };
      if (!isDefined(genReportMap)) genReportMap = new GenReportMap(casePath, 0xffffffff);
      obj = genReportMap.getMap(MAPSTYLES.FRP, 3);

      allData.data[eyeType].fourMaps.frp.map = obj.mapURL;
      allData.data[eyeType].fourMaps.frp.colorBarURL = obj.colorBarURL;
      if (fourmapsDrawSettings.mapInForm3.shapes.ShowNumericValues) {
        allData.data[eyeType].fourMaps.frp.numVals = obj.numVals;
      }
      if (fourmapsDrawSettings.mapInForm3.shapes.ShowMaxMin) {
        allData.data[eyeType].fourMaps.frp.minMaxVals = obj.minMaxVals;
      }
      dia = fourmapsDrawSettings.mapInForm3.shapes.ShowDiameter9mm ? 9 : 12;
      allData.data[eyeType].fourMaps.frp.numValsMap = renderMapValues(
        dia,
        allData.data[eyeType].fourMaps.frp.numVals,
        allData.data[eyeType].fourMaps.frp.minMaxVals,
        MAPSTYLES.FRP,
        fourmapsDrawSettings.mapInForm3.shapes
      );
      allData.data[eyeType].frp = {
        isPrinted: true,
        maps: allData.data[eyeType].fourMaps.frp,
        title: allData.cfg.langcfg.txtFRP,
        dia
      };
    } else {
      allData.data.printFlags.isFourMapsPrinted = false;
    }
  }
}

function normalKeratoconus(casePath, eyeType) {
  genReportMap = null;
  if (
    allData.cfg.printSettings.topography.reportName_bino.includes("keratoconus") &&
    !window.__ct__.debug
  ) {
    let keratoconusDrawSettings = allData.cfg.mapDrawSettings.keratoconus;
    let dia = 12;
    let obj;
    if (
      allData.record &&
      allData.record.content[`data${eyeType}`]["topography"] &&
      allData.record.content[`data${eyeType}`]["topography"].diagnosed
    ) {
      if (!isDefined(genReportMap)) genReportMap = new GenReportMap(casePath, 0xffffffff);
      obj = genReportMap.getMap(MAPSTYLES.SCurvatureF, 0);
      allData.data[eyeType].keratoconus.sCurvature.map = obj.mapURL;
      allData.data[eyeType].keratoconus.sCurvature.colorBarURL = obj.colorBarURL;
      if (keratoconusDrawSettings.mapInForm0.shapes.ShowNumericValues) {
        allData.data[eyeType].keratoconus.sCurvature.numVals = obj.numVals;
      }
      if (keratoconusDrawSettings.mapInForm0.shapes.ShowMaxMin) {
        allData.data[eyeType].keratoconus.sCurvature.minMaxVals = obj.minMaxVals;
      }
      dia = keratoconusDrawSettings.mapInForm0.shapes.ShowDiameter9mm ? 9 : 12;
      allData.data[eyeType].keratoconus.sCurvature.numValsMap = renderMapValues(
        dia,
        allData.data[eyeType].keratoconus.sCurvature.numVals,
        allData.data[eyeType].keratoconus.sCurvature.minMaxVals,
        MAPSTYLES.SCurvatureF,
        keratoconusDrawSettings.mapInForm0.shapes
      );

      if (!isDefined(genReportMap)) genReportMap = new GenReportMap(casePath, 0xffffffff);
      obj = genReportMap.getMap(MAPSTYLES.ElevationF, 1);
      allData.data[eyeType].keratoconus.elevation.map = obj.mapURL;
      allData.data[eyeType].keratoconus.elevation.colorBarURL = obj.colorBarURL;
      if (keratoconusDrawSettings.mapInForm1.shapes.ShowNumericValues) {
        allData.data[eyeType].keratoconus.elevation.numVals = obj.numVals;
      }
      if (keratoconusDrawSettings.mapInForm1.shapes.ShowMaxMin) {
        allData.data[eyeType].keratoconus.elevation.minMaxVals = obj.minMaxVals;
      }
      dia = keratoconusDrawSettings.mapInForm1.shapes.ShowDiameter9mm ? 9 : 12;
      allData.data[eyeType].keratoconus.elevation.numValsMap = renderMapValues(
        dia,
        allData.data[eyeType].keratoconus.elevation.numVals,
        allData.data[eyeType].keratoconus.elevation.minMaxVals,
        MAPSTYLES.ElevationF,
        keratoconusDrawSettings.mapInForm1.shapes
      );
    }
  }
}
function normalZernike(casePath, eyeType) {
  let maxPeak = { x: "--", y: "--" };
  let meanRms = { mean: "--", rms: "--" };
  if (
    allData.cfg.printSettings.topography.reportName_bino.includes("zernike") &&
    !window.__ct__.debug
  ) {
    if (
      allData.record &&
      allData.record.content[`data${eyeType}`]["topography"] &&
      allData.record.content[`data${eyeType}`]["topography"].diagnosed
    ) {
      genReportMap = new GenReportMap(casePath, 0xffffffff);
      let result = genReportMap.getZernikeImgs();
      let vals = [];
      if (isDefined(result)) {
        if (isDefined(result.values)) {
          for (let id = 0; id < result.values.length; id++) {
            if (isDataValid(result.values[id])) {
              result.values[id] *= 1000;
              vals.push(result.values[id]._toFixed(2));
            } else {
              vals.push("--");
            }
          }
        } else {
          vals = new Array(66);
          vals.fill("--");
        }
        if (isDefined(result.maxPeak)) {
          maxPeak.x = isDataValid(result.maxPeak.x) ? result.maxPeak.x._toFixed(2) : "--";
          maxPeak.y = isDataValid(result.maxPeak.y) ? result.maxPeak.y._toFixed(2) : "--";
        }
        if (isDefined(result.meanRms)) {
          meanRms.mean = isDataValid(result.meanRms.mean) ? result.meanRms.mean._toFixed(2) : "--";
          meanRms.rms = isDataValid(result.meanRms.rms) ? result.meanRms.rms._toFixed(2) : "--";
        }
      }
      allData.data[eyeType].aberration = {
        params: window.zernikeParams.params,
        svgPath: fileSys.getCfgPath("img/zernikes/"),
        values: vals,
        map: isDefined(result) ? result.mapURL : "",
        numValsMap: renderMapValues(
          window.zernikeSet.diameter,
          isDefined(result) ? result.numVals : null,
          null,
          MAPSTYLES.ElevationF
        ),
        isPrinted: true,
        zernikeSet: window.zernikeSet,
        maxPeak: maxPeak,
        meanRms: meanRms,
        retinal: {
          image: isDefined(result) && isDefined(result.retinal) ? result.retinal.URL : "",
          title: isDefined(result) && isDefined(result.retinal) ? result.retinal.title : ""
        },
        psf: {
          image: isDefined(result) && isDefined(result.psf) ? result.psf.URL : "",
          title: isDefined(result) && isDefined(result.psf) ? result.psf.title : "",
          label: isDefined(result) && isDefined(result.psf) ? result.psf.label : ""
        },
        chart: {
          image: isDefined(result) && isDefined(result.chart) ? result.chart.URL : "",
          title: isDefined(result) && isDefined(result.chart) ? result.chart.title : ""
        }
      };
    } else {
      allData.data.printFlags.isZernikePrinted = false;
    }
  }
}

function isContentValid(eyeType, mode) {
  let _mode = mode || "pupilcorneadia";
  return (
    isDefined(allData.record) &&
    isDefined(allData.record.content) &&
    isDefined(allData.record.content[`data${eyeType}`]) &&
    isDefined(allData.record.content[`data${eyeType}`][_mode]) &&
    allData.record.content[`data${eyeType}`][_mode].diagnosed
  );
}
function isModeDataValid(key, mode, eyeType) {
  return (
    isContentValid(eyeType, key) &&
    isDefined(allData.record.content[`data${eyeType}`][key]) &&
    isDefined(allData.record.content[`data${eyeType}`][key][mode])
  );
}

function drawPupilCenter(edgePupil, edgeCornea, data) {
  let canvas = document.createElement("canvas");
  canvas.width = 2048;
  canvas.height = 1536;
  // draw pupil
  let ctx = canvas.getContext("2d");
  ctx.lineWidth = 4;
  ctx.font = `50px arial`;
  ctx.setLineDash([10, 10]);
  if (edgePupil && isDataValid(edgePupil.r)) {
    ctx.save("translate");
    ctx.translate(edgePupil.x, edgePupil.y);
    ctx.strokeStyle = "#0f0";
    ctx.beginPath();
    ctx.arc(0, 0, edgePupil.r, 0, 2 * Math.PI, true);
    ctx.stroke();

    ctx.lineWidth = 3;
    ctx.setLineDash([6, 5]);
    ctx.beginPath();
    ctx.moveTo(-20, 0);
    ctx.lineTo(20, 0);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(0, -20);
    ctx.lineTo(0, 20);
    ctx.stroke();
    ctx.restore("translate");
  }
  ctx.lineWidth = 4;
  if (edgeCornea && isDataValid(edgeCornea.r)) {
    // draw cornea
    ctx.save("translate");
    ctx.strokeStyle = "yellow";
    ctx.translate(edgeCornea.x, edgeCornea.y);
    ctx.beginPath();
    ctx.arc(0, 0, edgeCornea.r, (20 / 180.0) * Math.PI, (-20 / 180.0) * Math.PI, true);
    ctx.stroke();
    ctx.beginPath();
    ctx.arc(
      0,
      0,
      edgeCornea.r,
      (20 / 180.0) * Math.PI + Math.PI,
      (-20 / 180.0) * Math.PI + Math.PI,
      true
    );
    ctx.stroke();
    ctx.lineWidth = 3;
    ctx.setLineDash([6, 5]);
    ctx.beginPath();
    ctx.moveTo(-20, 0);
    ctx.lineTo(20, 0);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(0, -20);
    ctx.lineTo(0, 20);
    ctx.stroke();
    ctx.restore("translate");
  }
  return canvas.toDataURL();
}
function normalPupilCornea(eyeType) {
  let isOldPupil = isContentValid(eyeType);
  let isNewPupil =
    isContentValid(eyeType, "pupilcorneadia_dark") ||
    isContentValid(eyeType, "pupilcorneadia_lowerMiddle") ||
    isContentValid(eyeType, "pupilcorneadia_middle") ||
    isContentValid(eyeType, "pupilcorneadia_bright") ||
    isContentValid(eyeType, "pupilcorneadia_dynamic");
  if (allData.cfg.printSettings.topography.reportName_bino.includes("pupilcorneadiameter")) {
    let coe = window.magecoe.pupilcornea;
    let edgePupil, edgeDark, edgeLowerMiddle, edgeMiddle, edgeBright, edgeCornea;
    let _edge;
    let _edgeMoved;
    if (isNewPupil || !isOldPupil) {
      allData.data[eyeType].pupilCornea.hasData = true;
      if (isModeDataValid("pupilcorneadia_dark", "pupildia", eyeType)) {
        _edge = allData.record.content[`data${eyeType}`]["pupilcorneadia_dark"]["pupildia"].edge;
        _edgeMoved =
          allData.record.content[`data${eyeType}`]["pupilcorneadia_dark"]["pupildia"].edgeMoved;
        edgeDark = isDataValid(_edge.r) ? _edge : _edgeMoved;
        let x =
            isDefined(edgeDark) && isDataValid(edgeDark.x) && isDataValid(edgeDark.rx)
              ? ((edgeDark.x - edgeDark.rx) * coe * 2)._toFixed(2)
              : "--",
          y =
            isDefined(edgeDark) && isDataValid(edgeDark.y) && isDataValid(edgeDark.ry)
              ? ((edgeDark.y - edgeDark.ry) * coe * 2)._toFixed(2)
              : "--";
        allData.data[eyeType].pupilCornea.dark = {
          ...cartesianToPolar(x, y),
          x: x === "--" ? "-- mm, " : `${x} mm, `,
          y: y === "--" ? "-- mm" : `${y} mm`,
          r:
            isDefined(edgeDark) && isDataValid(edgeDark.r)
              ? (edgeDark.r * coe * 2)._toFixed(2)
              : "--"
        };
      } else {
        allData.data[eyeType].pupilCornea.dark = {
          x: "--",
          y: "--",
          r: "--",
          radius: "--",
          angleDegrees: "--"
        };
      }
      if (isModeDataValid("pupilcorneadia_lowerMiddle", "pupildia", eyeType)) {
        _edge =
          allData.record.content[`data${eyeType}`]["pupilcorneadia_lowerMiddle"]["pupildia"].edge;
        _edgeMoved =
          allData.record.content[`data${eyeType}`]["pupilcorneadia_lowerMiddle"]["pupildia"]
            .edgeMoved;
        edgeLowerMiddle = isDataValid(_edge.r) ? _edge : _edgeMoved;
        let x =
            isDefined(edgeLowerMiddle) &&
            isDataValid(edgeLowerMiddle.x) &&
            isDataValid(edgeLowerMiddle.rx)
              ? ((edgeLowerMiddle.x - edgeLowerMiddle.rx) * coe * 2)._toFixed(2)
              : "--",
          y =
            isDefined(edgeLowerMiddle) &&
            isDataValid(edgeLowerMiddle.y) &&
            isDataValid(edgeLowerMiddle.ry)
              ? ((edgeLowerMiddle.y - edgeLowerMiddle.ry) * coe * 2)._toFixed(2)
              : "--";
        allData.data[eyeType].pupilCornea.lowerMiddle = {
          ...cartesianToPolar(x, y),
          x: x === "--" ? "-- mm, " : `${x} mm, `,
          y: y === "--" ? "-- mm" : `${y} mm`,
          r:
            isDefined(edgeLowerMiddle) && isDataValid(edgeLowerMiddle.r)
              ? (edgeLowerMiddle.r * coe * 2)._toFixed(2)
              : "--"
        };
      } else {
        allData.data[eyeType].pupilCornea.lowerMiddle = {
          x: "--",
          y: "--",
          r: "--",
          radius: "--",
          angleDegrees: "--"
        };
      }
      if (isModeDataValid("pupilcorneadia_middle", "pupildia", eyeType)) {
        _edge = allData.record.content[`data${eyeType}`]["pupilcorneadia_middle"]["pupildia"].edge;
        _edgeMoved =
          allData.record.content[`data${eyeType}`]["pupilcorneadia_middle"]["pupildia"].edgeMoved;
        edgeMiddle = isDataValid(_edge.r) ? _edge : _edgeMoved;
        let x =
            isDefined(edgeMiddle) && isDataValid(edgeMiddle.x) && isDataValid(edgeMiddle.rx)
              ? ((edgeMiddle.x - edgeMiddle.rx) * coe * 2)._toFixed(2)
              : "--",
          y =
            isDefined(edgeMiddle) && isDataValid(edgeMiddle.y) && isDataValid(edgeMiddle.ry)
              ? ((edgeMiddle.y - edgeMiddle.ry) * coe * 2)._toFixed(2)
              : "--";
        allData.data[eyeType].pupilCornea.middle = {
          ...cartesianToPolar(x, y),
          x: x === "--" ? "-- mm, " : `${x} mm, `,
          y: y === "--" ? "-- mm" : `${y} mm`,
          r:
            isDefined(edgeMiddle) && isDataValid(edgeMiddle.r)
              ? (edgeMiddle.r * coe * 2)._toFixed(2)
              : "--"
        };
      } else {
        allData.data[eyeType].pupilCornea.middle = {
          x: "--",
          y: "--",
          r: "--",
          radius: "--",
          angleDegrees: "--"
        };
      }
      if (isModeDataValid("pupilcorneadia_bright", "pupildia", eyeType)) {
        _edge = allData.record.content[`data${eyeType}`]["pupilcorneadia_bright"]["pupildia"].edge;
        _edgeMoved =
          allData.record.content[`data${eyeType}`]["pupilcorneadia_bright"]["pupildia"].edgeMoved;
        edgeBright = isDataValid(_edge.r) ? _edge : _edgeMoved;
        let x =
            isDefined(edgeBright) && isDataValid(edgeBright.x) && isDataValid(edgeBright.rx)
              ? ((edgeBright.x - edgeBright.rx) * coe * 2)._toFixed(2)
              : "--",
          y =
            isDefined(edgeBright) && isDataValid(edgeBright.y) && isDataValid(edgeBright.ry)
              ? ((edgeBright.y - edgeBright.ry) * coe * 2)._toFixed(2)
              : "--";
        allData.data[eyeType].pupilCornea.bright = {
          ...cartesianToPolar(x, y),
          x: x === "--" ? "-- mm, " : `${x} mm, `,
          y: y === "--" ? "-- mm" : `${y} mm`,
          r:
            isDefined(edgeBright) && isDataValid(edgeBright.r)
              ? (edgeBright.r * coe * 2)._toFixed(2)
              : "--"
        };
      } else {
        allData.data[eyeType].pupilCornea.bright = {
          x: "--",
          y: "--",
          r: "--",
          radius: "--",
          angleDegrees: "--"
        };
      }
      let key = isContentValid(eyeType, "pupilcorneadia_dark")
        ? "pupilcorneadia_dark"
        : isContentValid(eyeType, "pupilcorneadia_lowerMiddle")
          ? "pupilcorneadia_lowerMiddle"
          : isContentValid(eyeType, "pupilcorneadia_middle")
            ? "pupilcorneadia_middle"
            : "pupilcorneadia_bright";
      if (isModeDataValid(key, "corneadia", eyeType)) {
        _edge = allData.record.content[`data${eyeType}`][key]["corneadia"].edge;
        _edgeMoved = allData.record.content[`data${eyeType}`][key]["corneadia"].edgeMoved;
        edgeCornea = isDataValid(_edge.r) ? _edge : _edgeMoved;
        let x =
            isDefined(edgeCornea) && isDataValid(edgeCornea.x) && isDataValid(edgeCornea.rx)
              ? ((edgeCornea.x - edgeCornea.rx) * coe * 2)._toFixed(2)
              : "--",
          y =
            isDefined(edgeCornea) && isDataValid(edgeCornea.y) && isDataValid(edgeCornea.ry)
              ? ((edgeCornea.y - edgeCornea.ry) * coe * 2)._toFixed(2)
              : "--";
        allData.data[eyeType].pupilCornea.corneadia = {
          ...cartesianToPolar(x, y),
          x: x === "--" ? "-- mm, " : `${x} mm, `,
          y: y === "--" ? "-- mm" : `${y} mm`,
          r:
            isDefined(edgeCornea) && isDataValid(edgeCornea.r)
              ? (edgeCornea.r * coe * 2)._toFixed(2)
              : "--"
        };
      } else {
        allData.data[eyeType].pupilCornea.corneadia = {
          x: "--",
          y: "--",
          r: "--",
          radius: "--",
          angleDegrees: "--"
        };
      }
      if (isModeDataValid("pupilcorneadia_dynamic", "pupilArray", eyeType)) {
        allData.data[eyeType].pupilCornea.title =
          allData.cfg.langcfg.txtDynamicChangesInPupilDiameter;
        allData.data[eyeType].pupilCornea.seriesData =
          allData.record.content[`data${eyeType}`]["pupilcorneadia_dynamic"]["pupilArray"];
        Object.assign(
          allData.data[eyeType].pupilCornea.seriesData,
          puilCalDataMed(allData.data[eyeType].pupilCornea.seriesData)
        );
      }
    } else {
      if (isModeDataValid("pupilcorneadia", "corneadia", eyeType)) {
        _edge = allData.record.content[`data${eyeType}`]["pupilcorneadia"]["corneadia"].edge;
        _edgeMoved =
          allData.record.content[`data${eyeType}`]["pupilcorneadia"]["corneadia"].edgeMoved;
        edgeCornea = isDataValid(_edgeMoved.r) ? _edgeMoved : _edge;
        allData.data[eyeType].pupilCornea.cornea.x =
          isDefined(edgeCornea) && isDataValid(edgeCornea.r)
            ? (edgeCornea.x * coe)._toFixed(2) + " mm,"
            : "--,";
        allData.data[eyeType].pupilCornea.cornea.y =
          isDefined(edgeCornea) && isDataValid(edgeCornea.y)
            ? (edgeCornea.y * coe)._toFixed(2) + " mm,"
            : "--,";
        allData.data[eyeType].pupilCornea.cornea.r =
          isDefined(edgeCornea) && isDataValid(edgeCornea.r)
            ? (edgeCornea.r * coe * 2)._toFixed(2) + " mm"
            : "--";
      } else {
        allData.data[eyeType].pupilCornea.cornea = {
          x: "--",
          y: "--",
          r: "--"
        };
      }
      if (isModeDataValid("pupilcorneadia", "pupildia", eyeType)) {
        _edge = allData.record.content[`data${eyeType}`]["pupilcorneadia"]["pupildia"].edge;
        _edgeMoved =
          allData.record.content[`data${eyeType}`]["pupilcorneadia"]["pupildia"].edgeMoved;
        edgePupil = isDataValid(_edgeMoved.r) ? _edgeMoved : _edge;
        allData.data[eyeType].pupilCornea.pupil.x =
          isDefined(edgePupil) && isDataValid(edgePupil.r)
            ? (edgePupil.x * coe)._toFixed(2) + " mm, "
            : "--,";
        allData.data[eyeType].pupilCornea.pupil.y =
          isDefined(edgePupil) && isDataValid(edgePupil.r)
            ? (edgePupil.y * coe)._toFixed(2) + " mm, "
            : "--,";
        allData.data[eyeType].pupilCornea.pupil.r =
          isDefined(edgePupil) && isDataValid(edgePupil.r)
            ? (edgePupil.r * coe * 2)._toFixed(2) + " mm"
            : "--";
        allData.data[eyeType].isPrinted = true;
      } else {
        allData.data[eyeType].pupilCornea.pupil = {
          x: "--",
          y: "--",
          r: "--"
        };
      }
      calcDist(allData.data[eyeType], edgePupil, edgeCornea);
      if (isModeDataValid("pupilcorneadia", "photos", eyeType)) {
        let img = drawPupilCenter(edgePupil, edgeCornea, allData.data[eyeType].pupilCornea);
        let photos = allData.record.content[`data${eyeType}`]["pupilcorneadia"]["photos"];
        let photo = photos[0];
        const { serverip, serverport, sslport, serverssl } = window.server || {};
        let protocol = serverssl === 1 ? "https:" : "http:";
        let port = serverssl === 1 ? sslport : serverport;
        allData.data[eyeType].pupilCornea.image = isDefined(photo)
          ? `${protocol}//${serverip}:${port}/media/${photo.filename}?access_token=${window.token}`
          : "";
        allData.data[eyeType].pupilCornea.circleImage = img;
      }
    }
    allData.data[eyeType].pupilCornea.isPrinted = true;
  } else {
    allData.data[eyeType].pupilCornea.isPrinted = false;
  }
}

function puilCalDataMed(puilCorneaData) {
  let puilCalData = {};
  if (puilCorneaData.resultPupilDiameter) {
    // 计算初始位置
    const beginDiameter =
      puilCorneaData.resultPupilDiameter[0] === -1000
        ? "--"
        : (puilCorneaData.resultPupilDiameter[0] * 2 * window.magecoe.pupilcornea).toFixed(2);
    const beginOffsetx =
      puilCorneaData.resultPupilCenterX[0] === -1000 || puilCorneaData.ringCenterX[0] === -1000
        ? "--"
        : (
            (puilCorneaData.resultPupilCenterX[0] - puilCorneaData.ringCenterX[0]) *
            2 *
            window.magecoe.pupilcornea
          ).toFixed(2);
    const beginOffsety =
      puilCorneaData.resultPupilCenterY[0] === -1000 || puilCorneaData.ringCenterY[0] === -1000
        ? "--"
        : (
            (puilCorneaData.resultPupilCenterY[0] - puilCorneaData.ringCenterY[0]) *
            2 *
            window.magecoe.pupilcornea
          ).toFixed(2);

    puilCalData.start = {
      diameter: beginDiameter,
      offsetx: beginOffsetx,
      offsety: beginOffsety,
      index: 0,
      offsetR: cartesianToPolar(beginOffsetx, beginOffsety).radius,
      offsetAngle: cartesianToPolar(beginOffsetx, beginOffsety).angleDegrees
    };

    // 计算刺激开始位置
    const irritateDiameter =
      puilCorneaData.resultPupilDiameter[20] === -1000
        ? "--"
        : (puilCorneaData.resultPupilDiameter[20] * 2 * window.magecoe.pupilcornea).toFixed(2);
    const irritateOffsetx =
      puilCorneaData.resultPupilCenterX[20] === -1000 || puilCorneaData.ringCenterX[20] === -1000
        ? "--"
        : (
            (puilCorneaData.resultPupilCenterX[20] - puilCorneaData.ringCenterX[20]) *
            2 *
            window.magecoe.pupilcornea
          ).toFixed(2);
    const irritateOffsety =
      puilCorneaData.resultPupilCenterY[20] === -1000 || puilCorneaData.ringCenterY[20] === -1000
        ? "--"
        : (
            (puilCorneaData.resultPupilCenterY[20] - puilCorneaData.ringCenterY[20]) *
            2 *
            window.magecoe.pupilcornea
          ).toFixed(2);
    puilCalData.irritate = {
      diameter: irritateDiameter,
      offsetx: irritateOffsetx,
      offsety: irritateOffsety,
      index: 20,
      offsetR: cartesianToPolar(irritateOffsetx, irritateOffsety).radius,
      offsetAngle: cartesianToPolar(irritateOffsetx, irritateOffsety).angleDegrees
    };

    // 计算最小瞳孔位置
    const minDiameterInfo = findMinExcluding(puilCorneaData.resultPupilDiameter, -1000);

    const minDiameter =
      minDiameterInfo.minValue === 1000
        ? "--"
        : (minDiameterInfo.minValue * 2 * window.magecoe.pupilcornea).toFixed(2);
    const minOffsetx =
      minDiameterInfo.minIndex === 1000
        ? "--"
        : puilCorneaData.resultPupilCenterX[minDiameterInfo.minIndex] === -1000 ||
            puilCorneaData.ringCenterX[minDiameterInfo.minIndex] === -1000
          ? "--"
          : (
              (puilCorneaData.resultPupilCenterX[minDiameterInfo.minIndex] -
                puilCorneaData.ringCenterX[minDiameterInfo.minIndex]) *
              2 *
              window.magecoe.pupilcornea
            ).toFixed(2);
    const minOffsety =
      minDiameterInfo.minIndex === 1000
        ? "--"
        : puilCorneaData.resultPupilCenterY[minDiameterInfo.minIndex] === -1000 ||
            puilCorneaData.ringCenterY[minDiameterInfo.minIndex] === -1000
          ? "--"
          : (
              (puilCorneaData.resultPupilCenterY[minDiameterInfo.minIndex] -
                puilCorneaData.ringCenterY[minDiameterInfo.minIndex]) *
              2 *
              window.magecoe.pupilcornea
            ).toFixed(2);
    puilCalData.min = {
      diameter: minDiameter,
      offsetx: minOffsetx,
      offsety: minOffsety,
      index: minDiameterInfo.minIndex,
      offsetR: cartesianToPolar(minOffsetx, minOffsety).radius,
      offsetAngle: cartesianToPolar(minOffsetx, minOffsety).angleDegrees
    };
    // 计算瞳孔恢复位置
    const recoverDiameterIndex = findIndicesAfterValue(
      puilCorneaData.resultPupilDiameter,
      puilCorneaData.resultPupilDiameter[20]
    );
    const recoverDiameter =
      recoverDiameterIndex === 1000
        ? "--"
        : puilCorneaData.resultPupilDiameter[recoverDiameterIndex] === -1000
          ? "--"
          : (
              puilCorneaData.resultPupilDiameter[recoverDiameterIndex] *
              2 *
              window.magecoe.pupilcornea
            ).toFixed(2);
    const recoverOffsetx =
      recoverDiameterIndex === 1000
        ? "--"
        : puilCorneaData.resultPupilCenterX[recoverDiameterIndex] === -1000 ||
            puilCorneaData.ringCenterX[recoverDiameterIndex] === -1000
          ? "--"
          : (
              (puilCorneaData.resultPupilCenterX[recoverDiameterIndex] -
                puilCorneaData.ringCenterX[recoverDiameterIndex]) *
              2 *
              window.magecoe.pupilcornea
            ).toFixed(2);
    const recoverOffsety =
      recoverDiameterIndex === 1000
        ? "--"
        : puilCorneaData.resultPupilCenterY[recoverDiameterIndex] === -1000 ||
            puilCorneaData.ringCenterY[recoverDiameterIndex] === -1000
          ? "--"
          : (
              (puilCorneaData.resultPupilCenterY[recoverDiameterIndex] -
                puilCorneaData.ringCenterY[recoverDiameterIndex]) *
              2 *
              window.magecoe.pupilcornea
            ).toFixed(2);
    puilCalData.recover = {
      diameter: recoverDiameter,
      offsetx: recoverOffsetx,
      offsety: recoverOffsety,
      index: recoverDiameterIndex,
      offsetR: cartesianToPolar(recoverOffsetx, recoverOffsety).radius,
      offsetAngle: cartesianToPolar(recoverOffsetx, recoverOffsety).angleDegrees
    };

    // 计算T1
    puilCalData.T1 = {
      startTimeIndex: 20,
      endTimeIndex: calT(puilCorneaData.resultPupilDiameter).minIndex
    };

    // 计算T2
    puilCalData.T2 = { startTimeIndex: 40, endTimeIndex: recoverDiameterIndex };
  }
  return puilCalData;
}

function calT(arr) {
  let minValue = 1000;
  let minIndex = 1000;
  for (let i = 20; i <= 40; i++) {
    if (arr[i] !== -1000 && arr[i] < minValue) {
      minValue = arr[i];
      minIndex = i;
    }
  }
  return {
    minValue,
    minIndex
  };
}

function findIndicesAfterValue(arr, value) {
  if (value === -1000) {
    return 1000;
  }
  for (let i = 40; i < arr.length; i++) {
    if (arr[i] >= value) {
      return i;
    }
  }
  let maxValue = 0;
  let maxIndex = 0;
  for (let i = 40; i < arr.length; i++) {
    if (arr[i] !== -1000 && arr[i] > maxValue) {
      maxValue = arr[i];
      maxIndex = i;
    }
  }
  return maxIndex;
}

function findMinExcluding(arr, excludeValue) {
  // const filteredArray = arr.map((value, index) => ({ value, index })).filter(item => item.value !== excludeValue);
  let minValue = -excludeValue;
  let minIndex = -excludeValue;
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] !== excludeValue && arr[i] < minValue) {
      minValue = arr[i];
      minIndex = i;
    }
  }
  return { minValue, minIndex };
}

function cartesianToPolar(x, y) {
  if (x === "--" || y === "--" || x === -1000 || y === -1000) {
    return {
      radius: "-- mm",
      angle: "--", // 弧度
      angleDegrees: "-- °" // 度数
    };
  }
  // 计算半径 R
  const radius = Math.sqrt(x * x + y * y);
  // 计算角度 θ（弧度）
  let angle = Math.atan2(y, x);

  if (angle < 0) {
    angle += 2 * Math.PI;
  }

  // 如果需要角度（度数）
  const angleDegrees = angle * (180 / Math.PI);
  // 返回极坐标（半径和角度）
  return {
    radius: `${radius.toFixed(2)} mm`,
    angle, // 弧度
    angleDegrees: `${angleDegrees.toFixed(0)} °` // 度数
  };
}

function normalHeightFAndTFSQ(casePath, eyeType) {
  genReportMap = null;
  // const { FourMaps } = allData.cfg.printSettings.topography.bino
  // if (isFourMapsPrinted() && !window.__ct__.debug) {
  if (
    allData.cfg.printSettings.topography.reportName_bino.includes("heightfandtfsq") &&
    !window.__ct__.debug
  ) {
    let largemapSettings = allData.cfg.mapDrawSettings.largemap;

    let dia = 12;
    let obj;
    if (
      allData.record &&
      allData.record.content[`data${eyeType}`]["topography"] &&
      allData.record.content[`data${eyeType}`]["topography"].diagnosed
    ) {
      if (!isDefined(genReportMap)) genReportMap = new GenReportMap(casePath, 0xffffffff);
      obj = genReportMap.getMap(MAPSTYLES.HeightF, 0);
      allData.data[eyeType].heightFAndTFSQ.heightF.map = obj.mapURL;
      allData.data[eyeType].heightFAndTFSQ.heightF.colorBarURL = obj.colorBarURL;
      if (largemapSettings.mapInForm0.shapes.ShowNumericValues) {
        allData.data[eyeType].heightFAndTFSQ.heightF.numVals = obj.numVals;
      }
      if (largemapSettings.mapInForm0.shapes.ShowMaxMin) {
        allData.data[eyeType].heightFAndTFSQ.heightF.minMaxVals = obj.minMaxVals;
      }
      dia = largemapSettings.mapInForm0.shapes.ShowDiameter9mm ? 9 : 12;
      allData.data[eyeType].heightFAndTFSQ.heightF.numValsMap = renderMapValues(
        dia,
        allData.data[eyeType].heightFAndTFSQ.heightF.numVals,
        allData.data[eyeType].heightFAndTFSQ.heightF.minMaxVals,
        MAPSTYLES.heightF,
        largemapSettings.mapInForm0.shapes
      );
      allData.data[eyeType].heightF = {
        isPrinted: true,
        maps: allData.data[eyeType].heightFAndTFSQ.heightF,
        title: allData.cfg.langcfg.txtHeightF,
        dia
      };
      if (!isDefined(genReportMap)) genReportMap = new GenReportMap(casePath, 0xffffffff);
      obj = genReportMap.getMap(MAPSTYLES.TFSQ, 0);
      allData.data[eyeType].heightFAndTFSQ.tfsq.map = obj.mapURL;
      allData.data[eyeType].heightFAndTFSQ.tfsq.colorBarURL = obj.colorBarURL;
      if (largemapSettings.mapInForm0.shapes.ShowNumericValues) {
        allData.data[eyeType].heightFAndTFSQ.tfsq.numVals = obj.numVals;
      }
      if (largemapSettings.mapInForm0.shapes.ShowMaxMin) {
        allData.data[eyeType].heightFAndTFSQ.tfsq.minMaxVals = obj.minMaxVals;
      }
      dia = largemapSettings.mapInForm0.shapes.ShowDiameter9mm ? 9 : 12;
      allData.data[eyeType].heightFAndTFSQ.tfsq.numValsMap = renderMapValues(
        dia,
        allData.data[eyeType].heightFAndTFSQ.tfsq.numVals,
        allData.data[eyeType].heightFAndTFSQ.tfsq.minMaxVals,
        MAPSTYLES.TFSQ,
        largemapSettings.mapInForm0.shapes
      );
      allData.data[eyeType].tfsq = {
        isPrinted: true,
        maps: allData.data[eyeType].heightFAndTFSQ.tfsq,
        title: allData.cfg.langcfg.txtTFSQ,
        dia
      };
    } else {
      allData.data.printFlags.isHeightFAndTFSQPrinted = false;
    }
  }
}
function normalFourierAnalysis(casePath, eyeType) {
  genReportMap = null;
  // const { FourMaps } = allData.cfg.printSettings.topography.bino
  // if (isFourMapsPrinted() && !window.__ct__.debug) {
  if (
    allData.cfg.printSettings.topography.reportName_bino.includes("fourieranalysis") &&
    !window.__ct__.debug
  ) {
    let fourierAnalysisSettings = allData.cfg.mapDrawSettings.fourierAnalysis;

    let dia = 12;
    let obj;
    if (
      allData.record &&
      allData.record.content[`data${eyeType}`]["topography"] &&
      allData.record.content[`data${eyeType}`]["topography"].diagnosed
    ) {
      if (!isDefined(genReportMap)) genReportMap = new GenReportMap(casePath, 0xffffffff);
      obj = genReportMap.getMap("fourierAnalysis", 0);
      allData.data[eyeType].fourierAnalysis.sphericalComponent.map = obj.mapURL;
      allData.data[eyeType].fourierAnalysis.sphericalComponent.colorBarURL = obj.colorBarURL;
      allData.data[eyeType].fourierAnalysis.paramsSph = obj.calParams.paramsSph;
      allData.data[eyeType].fourierAnalysis.paramsDecent = obj.calParams.paramsDecent;
      allData.data[eyeType].fourierAnalysis.paramsRegular = obj.calParams.paramsRegular;
      allData.data[eyeType].fourierAnalysis.paramsIrregular = obj.calParams.paramsIrregular;
      if (fourierAnalysisSettings.mapInForm0.shapes.ShowNumericValues) {
        allData.data[eyeType].fourierAnalysis.sphericalComponent.numVals = obj.numVals;
      }
      if (fourierAnalysisSettings.mapInForm0.shapes.ShowMaxMin) {
        allData.data[eyeType].fourierAnalysis.sphericalComponent.minMaxVals = obj.minMaxVals;
      }
      dia = fourierAnalysisSettings.mapInForm0.shapes.ShowDiameter9mm ? 9 : 12;
      allData.data[eyeType].fourierAnalysis.sphericalComponent.numValsMap = renderMapValues(
        dia,
        allData.data[eyeType].fourierAnalysis.sphericalComponent.numVals,
        null,
        MAPSTYLES.SCurvatureF,
        fourierAnalysisSettings.mapInForm0.shapes
      );
      allData.data[eyeType].sphericalComponent = {
        isPrinted: true,
        maps: allData.data[eyeType].fourierAnalysis.sphericalComponent,
        title: allData.cfg.langcfg.txtSphericalComponent,
        dia
      };
      if (!isDefined(genReportMap)) genReportMap = new GenReportMap(casePath, 0xffffffff);
      obj = genReportMap.getMap("fourierAnalysis", 1);
      allData.data[eyeType].fourierAnalysis.decentration.map = obj.mapURL;
      allData.data[eyeType].fourierAnalysis.decentration.colorBarURL = obj.colorBarURL;
      if (fourierAnalysisSettings.mapInForm1.shapes.ShowNumericValues) {
        allData.data[eyeType].fourierAnalysis.decentration.numVals = obj.numVals;
      }
      if (fourierAnalysisSettings.mapInForm1.shapes.ShowMaxMin) {
        allData.data[eyeType].fourierAnalysis.decentration.minMaxVals = obj.minMaxVals;
      }
      dia = fourierAnalysisSettings.mapInForm1.shapes.ShowDiameter9mm ? 9 : 12;
      allData.data[eyeType].fourierAnalysis.decentration.numValsMap = renderMapValues(
        dia,
        allData.data[eyeType].fourierAnalysis.decentration.numVals,
        null,
        MAPSTYLES.SCurvatureF,
        fourierAnalysisSettings.mapInForm1.shapes
      );
      allData.data[eyeType].decentration = {
        isPrinted: true,
        maps: allData.data[eyeType].fourierAnalysis.decentration,
        title: allData.cfg.langcfg.txtDecentration,
        dia
      };
      if (!isDefined(genReportMap)) genReportMap = new GenReportMap(casePath, 0xffffffff);
      obj = genReportMap.getMap("fourierAnalysis", 3);
      allData.data[eyeType].fourierAnalysis.regularAstigmatism.map = obj.mapURL;
      allData.data[eyeType].fourierAnalysis.regularAstigmatism.colorBarURL = obj.colorBarURL;
      if (fourierAnalysisSettings.mapInForm3.shapes.ShowNumericValues) {
        allData.data[eyeType].fourierAnalysis.regularAstigmatism.numVals = obj.numVals;
      }
      if (fourierAnalysisSettings.mapInForm3.shapes.ShowMaxMin) {
        allData.data[eyeType].fourierAnalysis.regularAstigmatism.minMaxVals = obj.minMaxVals;
      }
      dia = fourierAnalysisSettings.mapInForm3.shapes.ShowDiameter9mm ? 9 : 12;
      allData.data[eyeType].fourierAnalysis.regularAstigmatism.numValsMap = renderMapValues(
        dia,
        allData.data[eyeType].fourierAnalysis.regularAstigmatism.numVals,
        null,
        MAPSTYLES.SCurvatureF,
        fourierAnalysisSettings.mapInForm3.shapes
      );
      allData.data[eyeType].regularAstigmatism = {
        isPrinted: true,
        maps: allData.data[eyeType].fourierAnalysis.regularAstigmatism,
        title: allData.cfg.langcfg.txtRegularAstigmatism,
        dia
      };
      if (!isDefined(genReportMap)) genReportMap = new GenReportMap(casePath, 0xffffffff);
      obj = genReportMap.getMap("fourierAnalysis", 4);
      allData.data[eyeType].fourierAnalysis.irregularity.map = obj.mapURL;
      allData.data[eyeType].fourierAnalysis.irregularity.colorBarURL = obj.colorBarURL;
      if (fourierAnalysisSettings.mapInForm4.shapes.ShowNumericValues) {
        allData.data[eyeType].fourierAnalysis.irregularity.numVals = obj.numVals;
      }
      if (fourierAnalysisSettings.mapInForm4.shapes.ShowMaxMin) {
        allData.data[eyeType].fourierAnalysis.irregularity.minMaxVals = obj.minMaxVals;
      }
      dia = fourierAnalysisSettings.mapInForm4.shapes.ShowDiameter9mm ? 9 : 12;
      allData.data[eyeType].fourierAnalysis.irregularity.numValsMap = renderMapValues(
        dia,
        allData.data[eyeType].fourierAnalysis.irregularity.numVals,
        null,
        MAPSTYLES.SCurvatureF,
        fourierAnalysisSettings.mapInForm4.shapes
      );
      allData.data[eyeType].irregularity = {
        isPrinted: true,
        maps: allData.data[eyeType].fourierAnalysis.irregularity,
        title: allData.cfg.langcfg.txtIrregularity,
        dia
      };
    } else {
      allData.data.printFlags.isFourierAnalysisPrinted = false;
    }
  }
}
function calcDist(data, pupil, cornea) {
  try {
    if (isDefined(pupil) && isDefined(cornea)) {
      data.pupilCornea.dist =
        (
          Math.sqrt(Math.pow(pupil.x - cornea.x, 2) + Math.pow(pupil.y - cornea.y, 2)) *
          window.magecoe.pupilcornea
        )._toFixed(2) + " mm";
    }
  } catch (e) {
    data.pupilCornea.dist = "--";
  }
}
async function initData(patient, record, cfg) {
  allData.cfg = cfg;
  allData.data = {
    patientInfo: {},
    OS: {},
    OD: {},
    printFlags: cfg.printSettings.topography.bino,
    langcfg: cfg.langcfg
  };
  allData.record = record;
  allData.data.printDate = formatDate(getSystemTime(), allData.cfg.dateFormat, true);
  genReportMap = null;
  let eyeType = "OS";
  allData.data.patientInfo = {
    name: window.__ct__.debug ? "Test" : "",
    pid: window.__ct__.debug ? "000000001" : "",
    sex: window.__ct__.debug ? "Male" : "",
    age: window.__ct__.debug ? "29" : "",
    birthday: window.__ct__.debug ? "1988-12-10" : ""
  };
  allData.data.hospitalInfo = cfg.printSettings.general;
  allData.data.checkDoctor = allData.cfg.printSettings.general.checkdoctor;
  allData.data.logoPath = fileSys.getCfgPath(cfg.printSettings.general.hospitallogo);
  allData.data.printFlags = cfg.printSettings.topography;
  allData.data.eye = "OD&OS";
  _init(eyeType);
  normalPatient(patient);
  let casePath = await initMapValues(eyeType);
  let isTopographyOS = isContentValid(eyeType, "topography");
  let isNewOSPupil =
    isContentValid(eyeType, "pupilcorneadia_dark") ||
    isContentValid(eyeType, "pupilcorneadia_lowerMiddle") ||
    isContentValid(eyeType, "pupilcorneadia_middle") ||
    isContentValid(eyeType, "pupilcorneadia_bright") ||
    isContentValid(eyeType, "pupilcorneadia_dynamic");
  if (!isDefined(casePath)) {
    allData.data[eyeType].isPrinted = false;
  } else if (isTopographyOS) {
    allData.data[eyeType].isPrinted = true;
    normalFourMaps(casePath, eyeType);
    normalKeratoconus(casePath, eyeType);
    normalZernike(casePath, eyeType);
    normalHeightFAndTFSQ(casePath, eyeType);
    normalFourierAnalysis(casePath, eyeType);
  } else {
    allData.data[eyeType].isPrinted = false;
  }
  normalPupilCornea(eyeType);

  eyeType = "OD";
  _init(eyeType);
  let isTopographyOD = isContentValid(eyeType, "topography");
  let isNewODPupil =
    isContentValid(eyeType, "pupilcorneadia_dark") ||
    isContentValid(eyeType, "pupilcorneadia_lowerMiddle") ||
    isContentValid(eyeType, "pupilcorneadia_middle") ||
    isContentValid(eyeType, "pupilcorneadia_bright") ||
    isContentValid(eyeType, "pupilcorneadia_dynamic");
  casePath = await initMapValues(eyeType);
  if (!isDefined(casePath)) {
    allData.data[eyeType].isPrinted = false;
  } else if (isTopographyOD) {
    allData.data[eyeType].isPrinted = true;
    normalFourMaps(casePath, eyeType);
    normalZernike(casePath, eyeType);
    normalKeratoconus(casePath, eyeType);
    normalHeightFAndTFSQ(casePath, eyeType);
    normalFourierAnalysis(casePath, eyeType);
  } else {
    allData.data[eyeType].isPrinted = false;
  }
  normalPupilCornea(eyeType);
  allData.data.isNewPupil = isNewOSPupil || isNewODPupil;
  return allData.data;
}
export default { initData, cartesianToPolar, puilCalDataMed };



// WEBPACK FOOTER //
// ./src/topography/js/reportBino.js